const MISSING_VALUE = '---';

export const datetimeFormatter = new Intl.DateTimeFormat("pt-BR", {
  dateStyle: "short",
  timeStyle: "medium",
});

export const hourFormatter = new Intl.NumberFormat("pt-BR", {
  style: "unit",
  unit: "hour",
  unitDisplay: "short",
  maximumFractionDigits: 2,
});

export const kmFormatter = new Intl.NumberFormat("pt-BR", {
  style: "unit",
  unit: "kilometer",
  unitDisplay: "short",
  maximumFractionDigits: 2,
});

export const numberFormatter = new Intl.NumberFormat("pt-BR", {
  style: "decimal",
  maximumFractionDigits: 2,
});

export const percentageFormatter = new Intl.NumberFormat("pt-BR", {
  style: "percent",
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export const valueStringFormat = (value: number, digits: number = 0) => {
  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "k" }, //mil
    { value: 1e6, symbol: "M" }, //milhão
    { value: 1e9, symbol: "B" }, //bilhão
    { value: 1e12, symbol: "T" }, //trilhao
    { value: 1e15, symbol: "Q" }, //quatrilhão
  ];
  const regexp = /\.0+$|(?<=\.[0-9]*[1-9])0+$/;
  const item = lookup.findLast(item => value >= item.value);
  return item ? (value / item.value).toFixed(digits).replace(regexp, "").concat(item.symbol) : "0";
}

export const formatCoordinates = (latitude: string, longitude: string) => {
  const toDMS = (valueStr: string): string => {
    const normalized = (valueStr ?? "").toString().trim().replace(/,/g, ".");
    const value = Number.parseFloat(normalized);
    if (Number.isNaN(value)) return valueStr ?? "";

    const sign = value < 0 ? -1 : 1;
    const abs = Math.abs(value);
    let degrees = Math.trunc(abs);
    const minutesFloat = (abs - degrees) * 60;
    let minutes = Math.trunc(minutesFloat);
    let seconds = Math.round((minutesFloat - minutes) * 60);

    // Normalize rounding overflow
    if (seconds === 60) {
      seconds = 0;
      minutes += 1;
    }
    if (minutes === 60) {
      minutes = 0;
      degrees += 1;
    }

    const signStr = sign < 0 ? "-" : "";
    return `${signStr}${degrees}º ${minutes}' ${seconds}"`;
  };

  return `${toDMS(latitude)}. ${toDMS(longitude)}`;
};

export const formatMeasuredValue = (
    item: string,
    tabName: string
  ): string => {
    const rawValue = Number.parseFloat(item);

    if (rawValue <= 0 || Number.isNaN(rawValue)) {
      return MISSING_VALUE;
    }

    if (["IT_SPEED", "IT_COASTING", "IT_CLUTCH", "IT_BRAKING"].includes(tabName)) {
      return `${rawValue} Km/h`;
    }

    if (["IT_KICKDOWN"].includes(tabName)) {
      return `${rawValue} %`;
    }

    if (["IT_RPM", "IT_IDLING", "IT_IDLING_AC"].includes(tabName)) {
      return `${rawValue} RPM`;
    }
    return String(rawValue);
  }

export const formatLatitudeLongitude = (
  latitude: number,
  longitude: number
) => {
  const toDMS = (value: number): string => {
    const normalized = (value ?? "").toString().trim().replace(/,/g, ".");
    const parsedValue = Number.parseFloat(normalized);
    if (Number.isNaN(parsedValue)) return String(value ?? 0);

    const sign = parsedValue < 0 ? -1 : 1;
    const abs = Math.abs(parsedValue);
    let degrees = Math.trunc(abs);
    const minutesFloat = (abs - degrees) * 60;
    let minutes = Math.trunc(minutesFloat);
    let seconds = Math.round((minutesFloat - minutes) * 60);

    // Normalize rounding overflow
    if (seconds === 60) {
      seconds = 0;
      minutes += 1;
    }
    if (minutes === 60) {
      minutes = 0;
      degrees += 1;
    }

    const signStr = sign < 0 ? "-" : "";
    return `${signStr}${degrees}º ${minutes}' ${seconds}"`;
  };

  return `${toDMS(latitude)}. ${toDMS(longitude)}`;
};

export const intToMonth = (monthNumber: number) => {
    if (monthNumber < 1 || monthNumber > 12) {
        return '';
    }

    const months: string[] = [
        "",
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro"
    ];

    return months[monthNumber];
}